import styled from 'styled-components';

export const Input = styled.div`
  background: white;
  min-height: 100%;
`
